import { NbAclOptions } from '@nebular/security';

// add here the operator admin resource
const OPERATOR_RESOURCES = [
  'dashboard',
  'all-notifications',
  'uploads',
  'requests',
  'requests-monitor-loading',
  'requests-monitor',
  'requests-bulk-loading',
  'requests-loading',
  'monitor-chronology',
  'monitor-flows',
  'monitor-appointments-booking',
  'monitor-appointments-change',
  'monitor-appointments-history',
  'monitor-cancel',
  'monitor-attachments',
  'flows',
  'flows-downloads',
  'flows-communications',
  'flows-pdr-registry',
  'credits',
  'credit-results',
  'self-readings',
  'upload-self-readings',
  'track-self-readings',
  'invoicing',
  'invoices',
  'warranties',
  'templates',
  'templates-requests',
  'templates-self-reports',
  'search',
  'search-pdr-address',
  'search-pdr-supplier',
  'search-pdr-request',
  'search-pdr-reading',
  'profile',
  'user-data',
  // 'user-data-header',
  'change-password'
];

// add here the admin resource
const ADMIN_RESOURCES = [
  'dashboard',
  'all-notifications',
  'uploads',
  'requests',
  'requests-monitor-loading',
  'requests-monitor',
  'requests-bulk-loading',
  'requests-loading',
  'monitor-chronology',
  'monitor-flows',
  'monitor-appointments-booking',
  'monitor-appointments-change',
  'monitor-appointments-history',
  'monitor-cancel',
  'monitor-attachments',
  'flows',
  'flows-downloads',
  'flows-communications',
  'flows-pdr-registry',
  'credits',
  'credit-results',
  'self-readings',
  'upload-self-readings',
  'track-self-readings',
  'invoicing',
  'invoices',
  'warranties',
  'templates',
  'templates-requests',
  'templates-self-reports',
  'search',
  'search-pdr-address',
  'search-pdr-supplier',
  'search-pdr-request',
  'search-pdr-reading',
  'profile',
  'user-data',
  'user-data-header',
  'change-password'
];

export const acl: NbAclOptions = {
  accessControl: {
    guest: {
      view: ['not-authorized']
    },
    operator: {
      view: OPERATOR_RESOURCES,
      create: OPERATOR_RESOURCES,
      edit: OPERATOR_RESOURCES,
      remove: OPERATOR_RESOURCES
    },
    admin: {
      view: ADMIN_RESOURCES,
      create: ADMIN_RESOURCES,
      edit: ADMIN_RESOURCES,
      remove: ADMIN_RESOURCES
    }
  }
};
